/* flow */
import React, { PureComponent } from 'react'
import Tooltip from 'antd/lib/tooltip'
import labels from './labels'
import {cellClassName, capitalize} from './globals'
import type {Lang, Mode} from './App'

type Props = {
  asc: boolean,
  sorter: ?Sorter,
  lang: Lang,
  width: number,
  grouped: 0 | 1,
  sort: (sorter: Sorter) => (e: SyntheticEvent<>)=> void,
  unselect: () => void,
  mode: Mode
}

const ufkListHeader = [
  {value: 'name',label: 'name', textAlign: 'left' },
  {value: 'code', label: 'code', textAlign: 'left' },
  {value: 'category', label: 'cat', textAlign: 'left' },
  {value: 'lastValuationDate', label: 'lastValuationDate', textAlign: 'center'},
  {value: 'valuation', label: 'val', textAlign: 'right'},
  {value: 'd', label: 'd', textAlign: 'right' }, 
  {value: 'm', label: 'm', textAlign: 'right' },
  {value: 'q', label: 'q', textAlign: 'right' },
  {value: 'y', label: 'y', textAlign: 'right' },
  {value: 'y3', label: 'y3', textAlign: 'right' },
  {value: 'y5', label: 'y5', textAlign: 'right' },
  {value: 'risk', label: 'risk', textAlign: 'center' }
]

const viennaListHeader = [
  {value: 'name',label: 'name', textAlign: 'left' },
  {value: 'code', label: 'code', textAlign: 'left' },
  {value: 'category', label: 'cat', textAlign: 'left' },
  {value: 'lastValuationDate', label: 'lastValuationDate', textAlign: 'center'},
  {value: 'valuation', label: 'val', textAlign: 'center'},
  {value: 'd', label: 'd', textAlign: 'right' },
  {value: 'm', label: 'm', textAlign: 'right' },
  {value: 'q', label: 'q', textAlign: 'right' },
  {value: 'hy', label: 'hy', textAlign: 'right' },
  {value: 'y', label: 'y', textAlign: 'right' },
  {value: 'y3', label: 'y3', textAlign: 'right' },
  {value: 'y5', label: 'y5', textAlign: 'right' },
  {value: 'ytd', label: 'ytd', textAlign: 'right' },
  {value: 'risk', label: 'risk', textAlign: 'center' }
]

const compensaListHeader = [
  {value: 'name',label: 'name', textAlign: 'left' },
  {value: 'category', label: 'cat', textAlign: 'left' },
  {value: 'lastValuationDate', label: 'lastValuationDate', textAlign: 'center'},
  {value: 'valuation', label: 'val', textAlign: 'right'},
  {value: 'recent', label: 'recent', textAlign: 'center' },
  {value: 'y', label: 'y', textAlign: 'center' },
  {value: 'y3', label: 'y3', textAlign: 'center' },
  {value: 'y5', label: 'y5', textAlign: 'center' },
  {value: 'max', label: 'max', textAlign: 'center' },
]

const  listHeaderByMode = (mode: Mode) =>  {
  switch (mode) {
    case "vienna": return viennaListHeader;
    case "compensa": return compensaListHeader;
    case "ufk": return ufkListHeader;
  }
}


export default class Header extends PureComponent<Props> {
  render() {
    const { sort, unselect, sorter, lang, asc, width, grouped, mode } = this.props
    return (
      <thead className="full-width ac-list__header">
        <tr>
          <UnselectSortCell
            lang={lang}
            sort={sort}
            unselect={unselect}
          />
          {(listHeaderByMode(mode)).map(({ value, label, textAlign }) =>
            <SorterCell
              key={value}
              value={value}
              textAlign={textAlign}
              className={`${grouped && label === 'cat' ? 'hide' : cellClassName(width, label)} sortable`}
              content={labels[lang][label + capitalize(mode)]}
              direction={sorter === value ? ( asc ? 'ascending' : 'descending') : null}
              sort={sort}
            />
          )}
          <th className={`csv ${cellClassName(width, 'csv')} center aligned`}>
            CSV
          </th>
        </tr>
      </thead>
    )
  }
}

type SorterCellProps = {
  value: Sorter,
  textAlign: string,
  direction: 'ascending' | 'descending' | null,
  className: string,
  content: string,
  sort: (sorter: Sorter) => (e: SyntheticEvent<>)=> void,
}

class SorterCell extends PureComponent<SorterCellProps> {
  render () {
    const { sort, value, textAlign, direction, className, content } = this.props
    return (
      <th
        className={`${className} ${textAlign} aligned ${direction ? `${direction} sorted` : ''} show sortable`}
        onClick={sort(value)}>
        {content}
      </th>
    )
  }
}

type UnselectSortProps = {
  lang: Laneg,
  sort: (sorter: Sorter) => (e: SyntheticEvent<>)=> void,
  unselect: () => void
}

class UnselectSortCell extends PureComponent<UnselectSortProps> {
  unselect = () => {
    const { unselect } = this.props
    unselect()
  }
  render() {
    const { sort, lang } = this.props
    return (
      <th className="center aligned checkbox"  rowSpan="2">
        <Tooltip title={labels[lang].unselectAll}>
          <i 
            aria-hidden="true"
            className="remove link icon"
            onClick={this.unselect}>
          </i>
        </Tooltip>
        <Tooltip title={labels[lang].raiseSelected}>
          <i 
            aria-hidden="true"
            className="arrow up link icon"
            onClick={sort('checked')}>
          </i>
        </Tooltip>
      </th>
    )
  }
}





// WEBPACK FOOTER //
// ./src/ListHeader.js